const LogHistory = (state = [], action) => {
    switch (action.type) {
        case 'ADMIN_LOGHISTORY_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default LogHistory